import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Messages from './icon-messages.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Messages {...validProps} />;
}
SvgComponent.iconName = 'messages';

/**
 * @deprecated This is a legacy icon
 */
export const MessagesIcon = svgIconWrapper(SvgComponent);
